/*eslint-disable*/
import api from '../'

class PaymentServicesApi {
    static list(params, cancelToken = null) {
        return api.axios.get('/payment-services', {params, cancelToken})
          .then(response => response.data);
    }

    static create(params) {
        return api.axios.post('/payment-services', params)
          .then(response => response.data);
    }

    static show(id) {
        return api.axios.get('/payment-services/' + id)
          .then(response => response.data);
    }

    static update(params) {
        return api.axios.put('/payment-services/' + params.id, params.paymentService)
          .then(response => response.data)
    }

    static delete(id) {
        return api.axios.delete('/payment-services/' + id)
          .then(response => response.data)
    }
}

export default PaymentServicesApi;
